var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCaratRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43009 19.1948L14.8701 12.7548C15.0701 12.5548 15.0701 12.2448 14.8701 12.0448L8.43009 5.6148C8.34009 5.5248 8.28009 5.3948 8.28009 5.2648L8.28009 3.8448C8.28009 3.3948 8.82009 3.1748 9.13009 3.4948L17.6901 12.0548C17.8901 12.2548 17.8901 12.5648 17.6901 12.7648L9.13009 21.3248C8.82009 21.6348 8.28009 21.4148 8.28009 20.9748L8.28009 19.5648C8.28009 19.4348 8.33009 19.3048 8.43009 19.2148L8.43009 19.1948Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCaratRight);
export default __webpack_public_path__ + "static/media/FBOCaratRight.dee49611e15e4ec82941209b77748bc9.svg";
export { ForwardRef as ReactComponent };